var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 17.0004H13.4583V13.4283C13.4578 12.8729 13.2369 12.3405 12.8442 11.9478C12.4516 11.5551 11.9191 11.3343 11.3638 11.3337H5.63621C5.08087 11.3343 4.54845 11.5551 4.15577 11.9478C3.76308 12.3405 3.54223 12.8729 3.54167 13.4283V17.0004H2.125V13.4283C2.12612 12.4974 2.49642 11.6049 3.15465 10.9467C3.81289 10.2885 4.70532 9.91818 5.63621 9.91705H11.3638C12.2947 9.91818 13.1871 10.2885 13.8453 10.9467C14.5036 11.6049 14.8739 12.4974 14.875 13.4283V17.0004Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.49994C7.65943 8.49994 6.83774 8.25068 6.13883 7.78369C5.43992 7.31669 4.89519 6.65293 4.57351 5.87635C4.25184 5.09976 4.16768 4.24523 4.33166 3.42081C4.49565 2.59639 4.90043 1.83911 5.4948 1.24474C6.08917 0.650364 6.84645 0.245591 7.67087 0.0816034C8.49529 -0.0823838 9.34982 0.00178043 10.1264 0.323453C10.903 0.645125 11.5668 1.18986 12.0337 1.88877C12.5007 2.58768 12.75 3.40937 12.75 4.24994C12.7489 5.37677 12.3007 6.45712 11.504 7.2539C10.7072 8.05069 9.62683 8.49882 8.5 8.49994ZM8.5 1.41661C7.93962 1.41661 7.39183 1.58278 6.92589 1.89411C6.45995 2.20544 6.09679 2.64795 5.88234 3.16567C5.66789 3.6834 5.61179 4.25308 5.72111 4.8027C5.83044 5.35231 6.10028 5.85716 6.49653 6.25341C6.89278 6.64966 7.39763 6.91951 7.94725 7.02883C8.49686 7.13816 9.06655 7.08205 9.58427 6.8676C10.102 6.65315 10.5445 6.29 10.8558 5.82406C11.1672 5.35812 11.3333 4.81032 11.3333 4.24994C11.3333 3.49849 11.0348 2.77782 10.5035 2.24647C9.97212 1.71512 9.25145 1.41661 8.5 1.41661Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsUser);
export default __webpack_public_path__ + "static/media/fi-rs-user.65184885892742bb605c6a0238da63db.svg";
export { ForwardRef as ReactComponent };